import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, DateTimeInput, FormActions, Checkbox } from '../../common/components/formControls';
import BackButton from '../../common/components/BackButton';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import TermsDropdownList from '../terms/DropdownList';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, t, onSendHolidayReminderChange, sendHolidayReminder, termId }) => {
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			{/* on a read-only holiday the term is left unfiltered so its name still shows in the disabled control */}
			{(!termId || termId == 0) && <TermsDropdownList render='field' name='termId' horizontal required disabled={isReadonly} editableOnly={!isReadonly}
				label={t('TermHolidayPeriod_Name')} validate={validators.required} />}
			<Field name='startDate' component={DateTimeInput} disabled={isReadonly} horizontal required showTime={false} label={t('TermHolidayPeriod_StartDate')} validate={[validators.required]} />
			<Field name='endDate' component={DateTimeInput} disabled={isReadonly} horizontal required showTime={false} label={t('TermHolidayPeriod_EndDate')} validate={[validators.required]} />
			<Field name='skipWeek' component={Checkbox} disabled={isReadonly} horizontal label={t('TermHoliday_SkipWeek')} normalize={(v) => { return !!v }} />
			<Field name='sendHolidayReminder' component={Checkbox} disabled={isReadonly} horizontal label={t('TermHoliday_SendHolidayReminder')} onChange={onSendHolidayReminderChange} normalize={(v) => { return !!v }} />
			{sendHolidayReminder && <Field name='reminderBeforeDays' component={Input} disabled={isReadonly} horizontal type='text' label={t('TermHoliday_ReminderBeforeDays')} validate={[validators.number]} />}
			<FormActions horizontal>
				<BackButton style={{ marginBottom: '10px' }}>{t('Common_BackToList')}</BackButton>
				<Button type='submit' disabled={isReadonly || pristine || submitting} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'termHolidayPeriod', enableReinitialize: true })(withTranslation()(SettingsForm));
